import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import FilesService from "../../services/files.service";
import { FaDownload } from "react-icons/fa"; // Import Font Awesome download icon

const PreviewFileModal = ({
  show,
  handleClose,
  file,
}) => {
 
  // const [isRejected, setIsRejected] = useState(false);
  // const [isApproved, setIsApproved] = useState(false);


  // const handleReject = () => {
  //   handleapprovedFile("rejected");
  //   setIsRejected(true);
  //   setIsApproved(false); // Remove approval when rejected
  // };

  // const handleApprove = () => {
  //   handleapprovedFile("approved");
  //   setIsApproved(true);
  //   setIsRejected(false); // Remove rejection when approved
  // };

  const [fileUrl, setFileUrl] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFile = async () => {
      if (!file?.id) {
        setFileUrl(null);
        setFileType(null);
        setLoading(false);
        setError("File id not provided.");
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const response = await FilesService.filePreview(file.id);
        // API now returns signed URL in response.data.url
        setFileUrl(response.data.url);
        setFileType(response.data.contentType);
      } catch (err) {
        setFileUrl(null);
        setFileType(null);
        setError("Failed to load file preview.");
      } finally {
        setLoading(false);
      }
    };
    fetchFile();
    // eslint-disable-next-line
  }, [file]);

  const downloadFile = () => {
    if (!fileUrl) return;
    // Signed URL can be used directly for download
    window.open(fileUrl, '_blank');
  };

  return (
    <Modal className="file_preview" show={show} onHide={handleClose} size="lg">
      <Modal.Header
        className="bg-dark text-white"
        style={{ '--bs-btn-close-color': 'white', position: 'relative' }}
      >
        <button
          onClick={handleClose}
          style={{
            position: 'absolute',
            top: '0.75rem',
            right: '1rem',
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '1.5rem',
            cursor: 'pointer',
          }}
          aria-label="Close"
        >
          &times;
        </button>
        <Modal.Title className="d-flex justify-content-between align-items-center w-100">
          <span>File Preview</span>
          {fileUrl && !loading && !error && (
            <button onClick={downloadFile} className="btn btn-white btn-sm bg-dark text-white fw-bold me-3">Download</button>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <h5>Loading...</h5>
          </div>
        ) : error ? (
          <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
            <h5>{error}</h5>
          </div>
        ) : fileUrl ? (
          <>
            {fileType === 'application/pdf' ? (
              <iframe src={fileUrl} width="100%" height="600px" title="File Viewer" />
            ) : fileType && fileType.startsWith('image/') ? (
              <img src={fileUrl} alt="File Preview" width="100%" height="auto" />
            ) : (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <h5>File preview not available</h5>
                <p>You can download the file using the button above.</p>
              </div>
            )}
          </>
        ) : (
          <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
            <h5>File not found</h5>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default PreviewFileModal;